import React, { memo, ReactElement, Children, cloneElement } from 'react'
import { IStickyHeaderStyleProps } from './Table'

export interface ITableHeadProps {
  id?: string
  children: ReactElement
  dataTest?: string
  stickyHeader?: boolean
  stickyHeaderStyle?: IStickyHeaderStyleProps
}

export const TableHead = memo<ITableHeadProps>(
  ({ children, dataTest, stickyHeader, stickyHeaderStyle }) => (
    <thead data-test={dataTest}>
      {Children.map(children, (child: ReactElement) =>
        cloneElement(child, { tableCellType: 'th', stickyHeader, stickyHeaderStyle })
      )}
    </thead>
  )
)
